import { ClipboardList } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const formsNav: NavEntry = {
  label: 'Forms',
  icon: ClipboardList,
  path: '/forms',
  permission: 'forms:read',
  order: 40,
}
